
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import { AuthContext } from "../helpers/AuthContext";

function EditGroupCategories() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authState } = useContext(AuthContext);
  const [apiUrl, setApiUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [group, setGroup] = useState(null);
  const [categories, setCategories] = useState([]);
  const [saving, setSaving] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  useEffect(() => {
    async function fetchConfigAndCategories() {
      const config = await loadConfig();
      setApiUrl(config.APIURL);
      // Fetch group info
      const groupRes = await axios.get(`${config.APIURL}/toolsgroups/${id}`, {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });
      setGroup(groupRes.data);
      // Fetch categories for this group
      const catRes = await axios.get(`${config.APIURL}/categories/toolsgroup/${id}`, {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });
      setCategories(catRes.data);
      setLoading(false);
    }
    fetchConfigAndCategories();
  }, [id]);

  const handleDelete = (categoryId) => {
    setPendingDeleteId(categoryId);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    setSaving(true);
    try {
      await axios.delete(`${apiUrl}/categories/${pendingDeleteId}`, {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });
      setCategories(categories.filter(cat => cat.id !== pendingDeleteId));
      setShowConfirm(false);
      setPendingDeleteId(null);
    } catch (err) {
      alert("Fehler beim Löschen der Kategorie.");
    }
    setSaving(false);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
    setPendingDeleteId(null);
  };

  if (loading || !group) {
    return <LoadingSpinner text="Lade Gerätegruppe..." />;
  }

  if (!authState.isAdmin) {
    return (
      <div className="container page-offset-100" style={{ textAlign: 'center' }}>
        <h2>⚠️ Zugriff verweigert</h2>
        <p>Nur Administratoren können Prüfkategorien bearbeiten.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h2>Prüfkategorien für: {group.groupname}</h2>
      <div className="mb-3">
        <button className="btn btn-primary" onClick={() => navigate(`/edit-group-category/${id}/new`)}>Kategorie hinzufügen</button>
      </div>
      <table className="table table-stack">
        <thead>
          <tr>
            <th>Name</th>
            <th>Intervall</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((cat) => (
            <tr key={cat.id}>
              <td data-label="Name">{cat.name}</td>
              <td data-label="Intervall">{cat.interval} {cat.unit}</td>
              <td data-label="Aktionen">
                <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/edit-group-category/${id}/${cat.id}`)}>Bearbeiten</button>
                <button className="btn btn-danger btn-sm" style={{ marginLeft: "8px" }} onClick={() => handleDelete(cat.id)} disabled={saving}>Löschen</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="btn btn-secondary" style={{ marginTop: "16px" }} onClick={() => navigate("/toolsgroups")}>Zurück</button>

      {/* Custom Confirmation Modal */}
      {showConfirm && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}>
          <div style={{
            background: "#fff",
            borderRadius: "8px",
            padding: "32px 24px 24px 24px",
            width: "min(360px, 92vw)",
            boxSizing: "border-box",
            boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
            textAlign: "center"
          }}>
            <h5 style={{ marginBottom: "16px", color: "#b71c1c" }}>Kategorie löschen?</h5>
            <p style={{ marginBottom: "24px" }}>Möchten Sie diese Kategorie wirklich löschen?<br/>Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
            <button className="btn btn-danger" style={{ marginRight: "12px", minWidth: 90 }} onClick={confirmDelete} disabled={saving}>
              {saving ? "Lösche..." : "Löschen"}
            </button>
            <button className="btn btn-secondary" style={{ minWidth: 90 }} onClick={cancelDelete} disabled={saving}>Abbrechen</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditGroupCategories;
